<template>
    <div>
        <app-layout />
        <!-- <app-loading v-if="inProgress"></app-loading> -->
    </div>
</template>
<script>
import Layout from "./UI/Layout/Layout.vue";

export default {
    name: "shatter-app",
    components: {
        appLayout: Layout
    }
};
</script>
